import { render, staticRenderFns } from "./ObservationCreate.vue?vue&type=template&id=b9d073b8"
import script from "./ObservationCreate.vue?vue&type=script&lang=js"
export * from "./ObservationCreate.vue?vue&type=script&lang=js"
import style0 from "./ObservationCreate.vue?vue&type=style&index=0&id=b9d073b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports